export default {
  guide_last_step:'Previous',
  guide_next_step:'Next',
  guide_more_step:'More',

  guide_overview_daily_step1_title: 'Core Function 1',
  guide_overview_daily_step1_subtitle: 'View the daily operation data and related events of the game',
  guide_overview_daily_step1_description: 'Click on the axis of core metric line chart to view corresponding event analysis for the day.',

  guide_overview_daily_step2_title: 'Core Function 1',
  guide_overview_daily_step2_subtitle: "View the dimension data for the game's daily operation overview",
  guide_overview_daily_step2_description: 'Select the dimension to view the metric data for the different countries.',

  guide_overview_daily_step3_title: 'Core Function 1 ',
  guide_overview_daily_step3_subtitle: "View the focus metrics and statistical data of the game's daily operation overview",
  guide_overview_daily_step3_description: 'Click on the settings to adjust the metrics displayed in the table or view more statistical data.',

  guide_realtime_user_step1_title: 'Core Function 2',
  guide_realtime_user_step1_subtitle: 'View real-time data for global game users',
  guide_realtime_user_step1_description: 'Select different dates on the real-time user page to view real-time data for two comparison dates.',

  guide_realtime_user_step2_title: 'Core Function 2',
  guide_realtime_user_step2_subtitle: 'View real-time data for game users by country/by region/by zone',
  guide_realtime_user_step2_description: 'Use the drop-down filter to view the chart of real-time data for different countries/regions/zones.',

  guide_realtime_user_step3_title: 'Core Function 2',
  guide_realtime_user_step3_subtitle: 'View the  real-time metric change of game users in different countries',
  guide_realtime_user_step3_description: 'Use the drop-down filter to view the real-time metric change that are the same or opposite to the global trend.',

  guide_country_comparison_step1_title: 'Core Function 3',
  guide_country_comparison_step1_subtitle: 'View global multi-timezone data, compare data by country',
  guide_country_comparison_step1_description: 'Select two or more countries, analyze and compare data from different countries.',
 
  guide_country_comparison_step2_title: 'Core Function 3',
  guide_country_comparison_step2_subtitle: 'View local timezone data',
  guide_country_comparison_step2_description: 'Select a country to view local timezone data.',

  guide_tableau_step1_title: 'Core Function 4',
  guide_tableau_step1_subtitle: 'View customized game dashboard',
  guide_tableau_step1_description: 'Click on a customized dashboard to enter the page, and view analysis data for gameplay, levels, activities, etc. You can download data for additional analysis.',

  guide_subscribe_step1_title: 'Core Function 5',
  guide_subscribe_step1_subtitle: 'Dashboard Subscription and Push',
  guide_subscribe_step1_description: 'Click on the "More operations" option on any dashboard, select "Subscribe" to enter the subscription settings.',
 
  guide_subscribe_step2_title: 'Core Function 5',
  guide_subscribe_step2_subtitle: 'Dashboard Subscription and Push',
  guide_subscribe_step2_description: 'On the "Subscription Settings" page, you can configure the push frequency, daily,weekly, or monthly . If you need to unsubscribe, you can cancel on the "Subscription Management" page.',
}
